import { FormattersTypes } from '@/services/types/formatter'


export default ({ vtag, component, data, key, ctx }: FormattersTypes) => {
  component.tag = 'span';
  const getText = () =>{
    switch(data[key]) {
      case 1:
        return '✅';
      case 0:
        return '❌';
      default:
        return '';
    }
  }

  return vtag('div', {style: {}},
    [
        getText()
    ]
  );
}
